import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Divider,
  Button,
  useMediaQuery,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGlobalState } from "../../contexts/GlobalContext";
import {
  authenticateSSOUser,
  fetchUpdateUserMeataData,
  postMassmedian,
} from "../../utils/helpers/api";
import { error } from "console";

const Massmedian: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { globalState, setStateValue, setGlobalState, refreshAccessToken } =
    useGlobalState();
  const { user } = globalState ?? {};
  const { user_id, user_metadata } = user ?? {};

  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [checked1Error, setChecked1Error] = useState("");
  const [checked2Error, setChecked2Error] = useState("");
  const [checked3Error, setChecked3Error] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isAllAgreed, setIsAllAgreed] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isSuccessMassmedian, setSuccessMassmedian] = useState(false);
  const [urlBack, setUrlBack] = useState("");
  const [isComposing, setIsComposing] = useState(false);

  const toHalfWidth = (str: string) => {
    let result = str.replace(/[０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
    result = result.replace(/[－―ー—–−]/g, "-");
    return result;
  };
   const handleChange = (e: string) => {
    let raw = e;
    if (!isComposing) {
      setPhone(toHalfWidth(raw));
    } else {
      setPhone(raw);
    }
  };
  const getValidationError = ({
    value,
    type,
    maxLength = 256,
  }: {
    value: string;
    type: "email" | "phone";
    maxLength?: number;
  }): string => {
    if (value.length > maxLength) {
      return type === "email"
        ? "メールアドレス欄は256文字を超えてはいけません。"
        : "電話番号欄は256文字を超えてはいけません。";
    }

    if (value.length > 0 && type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "メールアドレスを正しく入力してください。";
    }

    if (
      value.length > 0 &&
      type === "phone" &&
      !/^[0-9０-９\-－―ー—–−]+$/.test(value)
    ) {
      return "電話番号は数字とハイフンのみ入力してください。";
    }

    return "";
  };

  const handleSubmit = async () => {
    let hasError = false;

    if (!checked1) {
      setChecked1Error("この項目は必須です。");
      hasError = true;
    } else {
      setChecked1Error("");
    }
    if (!checked2) {
      setChecked2Error("この項目は必須です。");
      hasError = true;
    } else {
      setChecked2Error("");
    }
    if (!checked3) {
      setChecked3Error("この項目は必須です。");
      hasError = true;
    } else {
      setChecked3Error("");
    }

    const emailErr = getValidationError({ value: email, type: "email" });
    const phoneErr = getValidationError({ value: phone, type: "phone" });

    setEmailError(emailErr);
    setPhoneError(phoneErr);

    if (emailErr || phoneErr || hasError) {
      return;
    }
    setStateValue("loader", true);

    try {
      const result = await postMassmedian(email, phone);
      if (result.status === "true") {
        if (user_metadata && user_id) {
          updateAuthenticated(user_id, {
            ...user_metadata,
            registeredRecruitingService: true,
          });
          setGlobalState({
            ...globalState,
            user: {
              ...globalState.user,
              user_metadata: {
                ...user_metadata,
                registeredRecruitingService: true,
              },
            },
          });
          await refreshAccessToken();
          setSuccessMassmedian(true);
          window.scrollTo({ top: 0, behavior: "smooth" });
          if (urlBack) {
            window.location.href = urlBack;
          }
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setStateValue("loader", false);
    }
  };

  const updateAuthenticated = async (
    user_id: string,
    data: IUserMetaDataApi
  ) => {
    try {
      await fetchUpdateUserMeataData(user_id ?? "", data);
      await authenticateSSOUser(
        globalState.user.email,
        globalState.user.user_id
      );
    } catch (err) {
      return err;
    }
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlBackParam = params.get("urlback");

    if (urlBackParam) {
      setUrlBack(urlBackParam);
    }
  }, []);

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", p: 3 }}>
      {isSuccessMassmedian && (
        <Alert
          sx={{
            bgcolor: "#dff0d8",
            color: "#3c763d",
          }}
          className="mt-3 mb-3"
          icon={false}
          severity="success"
          onClose={() => {
            setSuccessMassmedian(false)
          }}
        >
          {t("features.userSetting.registerCompleted")}
        </Alert>
      )}
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontSize: 20, fontWeight: 500, fontFamily: '"Noto Sans JP", sans-serif', }}
      >
        求人紹介サービスへの登録に関する同意
      </Typography>

      <Typography
        variant="body1"
        gutterBottom
        sx={{ fontSize: 16, fontWeight: 500, fontFamily: '"Noto Sans JP", sans-serif', }}
      >
        株式会社宣伝会議では、メディアによる情報提供やスキルアップ・キャリアアップを促進する教育講座のみならず、様々な業界で活躍する皆様を多角的に支援するため、グループ会社である
        <strong>
          「
          <a
            href="https://www.massmedian.co.jp/"
            rel="noopener"
            className="register-form-input_external -vertical"
            target="_blank"
          >
            株式会社マスメディアン
          </a>
          」
        </strong>
        と提携し、お仕事を紹介する取り組みも行っています。
      </Typography>

      <Box
        sx={{
          my: 3,
          px: 3,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src="/images/massmedianimg.png"
          alt="説明画像"
          style={{ width: "680px", height: "200px", gap: "10px" }}
        />
      </Box>

      <Typography
        sx={{ mb: 3,mt: 2, fontWeight: 500, fontSize: 16, fontFamily: '"Noto Sans JP", sans-serif', }}
        variant="body2"
        gutterBottom
      >
        本ページで以下3つの内容にご同意いただくことで、様々な情報登録を省き、かんたんにマスメディアンの求人紹介サービスに登録することができます。ご登録いただいた皆さまへは、宣伝会議グループが提供するキャリアアップ・転職に役立つコンテンツ群を利用しつつ、もしぴったりの求人情報があった場合に株式会社マスメディアンのキャリアコンサルタントからご連絡差し上げることができます。
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography
          sx={{ mb: 1, fontWeight: 500, fontSize: 16, fontFamily: '"Noto Sans JP", sans-serif', }}
          variant="body2"
        >
          1. 株式会社マスメディアンの個人情報の取り扱い、利用規約に関する同意
        </Typography>
        <Typography
          sx={{ mb: 1, fontWeight: 500, fontSize: 16, fontFamily: '"Noto Sans JP", sans-serif', }}
          variant="body2"
        >
          2. 取り扱い職種の範囲等の明示の確認
        </Typography>
        <Typography
          sx={{ mb: 1, fontWeight: 500, fontSize: 16, fontFamily: '"Noto Sans JP", sans-serif', }}
          variant="body2"
        >
          3. 宣伝会議からマスメディアンへの登録情報の提供に関する同意
        </Typography>
      </Box>

      <Box
        sx={{
          border: "1px solid #F0F0F0",
          borderRadius: 1.5,
          px: 2,
          bgcolor: "#fff",
          display: "inline-block",
          my: 1,
        }}
      >
        <FormControlLabel
          sx={{ fontSize: 16 }}
          control={
            <Checkbox
              checked={checked1}
              onChange={(e) => {
                setChecked1(e.target.checked);
                if (e.target.checked) setChecked1Error("");
              }}
            />
          }
          label={
            <span style={{ fontSize: 16, fontWeight: 500, fontFamily: '"Noto Sans JP", sans-serif', }}>
              株式会社マスメディアン{" "}
              <a
                href="https://www.massmedian.co.jp/privacy/"
                rel="noopener"
                target="_blank"
                style={{ color: "#007383" }}
              >
                個人情報の取り扱い
              </a>
              、
              <a
                href="https://ecoriku.jp/terms.html"
                rel="noopener"
                target="_blank"
                style={{ color: "#007383" }}
              >
                「エコリク」利用規約
              </a>
              に同意する
            </span>
          }
        />
        {checked1Error && (
          <Typography color="error" sx={{ fontSize: 14 }}>
            {checked1Error}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          border: "1px solid #F0F0F0",
          borderRadius: 1.5,
          px: 2,
          bgcolor: "#fff",
          display: "inline-block",
          my: 1,
        }}
      >
        <FormControlLabel
          sx={{ fontSize: 16 }}
          control={
            <Checkbox
              checked={checked2}
              onChange={(e) => {
                setChecked2(e.target.checked);
                if (e.target.checked) setChecked2Error("");
              }}
            />
          } 
          label={
            <span style={{ fontSize: 16, fontWeight: 500, fontFamily: '"Noto Sans JP", sans-serif', }}>
              株式会社マスメディアン{" "}
              <a
                href="https://files.massmedian.co.jp/data/meiji.pdf"
                rel="noopener"
                target="_blank"
                style={{ color: "#007383" }}
              >
                取り扱い職種の範囲等の明示
              </a>
              を確認しました
            </span>
          }
        />
        {checked2Error && (
          <Typography color="error" sx={{ fontSize: 14 }}>
            {checked2Error}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          border: "1px solid #F0F0F0",
          borderRadius: 1.5,
          p: 2.5,
          bgcolor: "#fff",
          my: 1,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ color: "#007383", fontWeight: 600, mb: 2, fontSize: 16, fontFamily: '"Noto Sans JP", sans-serif', }}
        >
          株式会社宣伝会議から株式会社マスメディアンへの個人情報提供内容
        </Typography>

        <Typography variant="body2" sx={{ mb: 1, fontSize: 16, fontFamily: '"Noto Sans JP", sans-serif', }}>
          <Typography sx={{ fontSize: 16, mb: 1, fontWeight: 500, fontFamily: '"Noto Sans JP", sans-serif', color: "#595F5E", }}>
            個人情報の提供目的
          </Typography>
          <strong style={{ fontSize: 14 }}>
            株式会社宣伝会議は
            プライバシーポリシー第4条「個人情報の第三者提供」に則り、ご登録いただいた個人情報の一部を以下の目的で株式会社マスメディアンに提供します。
            <ol style={{ paddingLeft: "1.25rem" }}>
              <li>キャリアアドバイザーが適した求人案件を紹介・選定するため</li>
              <li>
                キャリアアドバイザーが選定した求人案件をおススメ・紹介する際のご連絡
              </li>
            </ol>
          </strong>
        </Typography>

        <Typography variant="body2" sx={{ mb: 2, fontSize: 16, fontFamily: '"Noto Sans JP", sans-serif', }}>
          <Typography sx={{ fontSize: 16, mb: 1, fontWeight: 500, fontFamily: '"Noto Sans JP", sans-serif', color: "#595F5E", }}>
            提供する個人情報の種類
          </Typography>
          <strong style={{ fontSize: 14 }}>
            提供目的に必要な情報のため、以下の個人情報を株式会社マスメディアンへ提供します。
            <br />
            <ol style={{ paddingLeft: "1.25rem" }}>
              <li>
                お名前、お名前のふりがな、メールアドレス、お電話番号(ご連絡に使用いたします)
              </li>
              <li>
                ご所属の企業名、部署名、職種、ご購入・ご利用いただいた教育講座やイベントの種類、ご購読いただいているメディアなどの利用履歴
                (適切な求人情報を検討・選定するため参考にさせていただきます)
              </li>
            </ol>
          </strong>
        </Typography>

        <Box
          sx={{
            border: "1px solid #F0F0F0",
            borderRadius: 1.5,
            px: 2,
            bgcolor: "#fff",
            display: "inline-block",
          }}
        >
          <FormControlLabel
            sx={{ fontSize: 16 }}
            control={
              <Checkbox
                checked={checked3}
                onChange={(e) => {
                  setChecked3(e.target.checked);
                  if (e.target.checked) setChecked3Error("");
                }}
              />
            }
            label={
              <span style={{ fontSize: 16, fontWeight: 500, fontFamily: '"Noto Sans JP", sans-serif', }}>
                株式会社マスメディアンへの個人情報提供内容に同意する
              </span>
            }
          />
          {checked3Error && (
            <Typography color="error" sx={{ fontSize: 14, mt: 1 }}>
              {checked3Error}
            </Typography>
          )}
        </Box>
      </Box>

      <Box sx={{ my: 1 }}>
        <Box
          sx={{
            border: "1px solid #F0F0F0",
            borderRadius: 1.5,
            p: 2.5,
            bgcolor: "#fff",
          }}
        >
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ color: "#007383", fontWeight: 600, fontSize: 16, mb: 2, fontFamily: '"Noto Sans JP", sans-serif', }}
          >
            お仕事紹介のご連絡に適したメールアドレス
          </Typography>

          <Typography
            variant="body2"
            gutterBottom
            sx={{ fontSize: 14, fontWeight: 600, fontFamily: '"Noto Sans JP", sans-serif', }}
          >
            現在ご登録いただいているものとは別に、求人情報のご連絡に適したメールアドレスやお電話番号があればご記入ください。
          </Typography>

          <TextField
            fullWidth
            placeholder="example@sendenkaigi.co.jp"
            variant="outlined"
            type="email"
            sx={{
              my: 1,
              "& .MuiOutlinedInput-root": {
                height: 33,
                padding: 0,
                "& input": {
                  height: 33,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  paddingLeft: "12px",
                  paddingRight: "8px",
                  fontSize: 16,
                  boxSizing: "border-box",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#00626F",
                  borderWidth: "1px",
                },
              },
            }}
            value={email}
            onChange={(e) => {
              const val = e.target.value;
              setEmail(val);
              setEmailError(getValidationError({ value: val, type: "email" }));
            }}
            error={!!emailError}
            helperText={emailError}
          />

          <TextField
            fullWidth
            placeholder="080-1234-5678"
            variant="outlined"
            type="tel"
            sx={{
              my: 1,
              "& .MuiOutlinedInput-root": {
                height: 33,
                padding: 0,
                "& input": {
                  height: 33,
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  paddingLeft: "12px",
                  paddingRight: "8px",
                  fontSize: 16,
                  boxSizing: "border-box",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#00626F",
                  borderWidth: "1px",
                },
              },
            }}
            value={phone}
            onChange={(e) => {
              handleChange(e.target.value);
              setPhoneError(getValidationError({ value: e.target.value, type: "phone" }));
            }}
            onCompositionStart={() => setIsComposing(true)}
            onCompositionEnd={(e) => {
              setIsComposing(false);
              const val = toHalfWidth(phone);
              setPhone(val);
              setPhoneError(getValidationError({ value: val, type: "phone" }));
            }}
            error={!!phoneError}
            helperText={phoneError}
          />
        </Box>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}>
        <Button
          onClick={() => {
            if (urlBack) {
              window.location.href = urlBack;
            } else {
              navigate(-1);
            }
          }}
          sx={{
            width: 216,
            height: 52,
            minWidth: 160,
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "18px",
            paddingRight: "16px",
            paddingBottom: "18px",
            paddingLeft: "16px",
            borderRadius: "8px",
            fontSize: 16,
            textAlign: "center",
            backgroundColor: "#FFFFFF !important",
            color: "#007383 !important",
            border: "1px solid #F0F0F0",
            fontFamily: '"Noto Sans JP", sans-serif',
          }}
        >
          戻る
        </Button>

        <Button
          disabled={isAllAgreed}
          onClick={handleSubmit}
          sx={{
            width: 216,
            height: 52,
            minWidth: 160,
            justifyContent: "center",
            alignItems: "center",
            padding: "18px 16px",
            borderRadius: "8px",
            fontSize: 16,
            textAlign: "center",
            backgroundColor: "#007383 !important",
            color: "#fff !important",
            fontFamily: '"Noto Sans JP", sans-serif',
          }}
        >
          登録
        </Button>
      </Box>
    </Box>
  );
};

export default Massmedian;
